import { createVuetify } from 'vuetify'
import 'vuetify/styles'

import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

const relevizeDefaultTheme = {
  dark: false,
  colors: {
    primary: '#000000',
    error: '#E4000F',
    info: '#FFE6B2',
    success: '#4CAF50',
    warning: '#F0F9F2',
    malachite: '#00D86C',
    'relevize-black': '#000000',
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'relevizeDefaultTheme',
    themes: {
      relevizeDefaultTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})
